var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showApplePayButton)?_c('apple-pay-button',{attrs:{"buttonstyle":_vm.color,"type":"buy","locale":_vm.lang,"disabled":_vm.disabled,"id":"apple-pay-button"},on:{"click":_vm.onClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }